import config from "./config";
export const API_URL = config.apiUrl;
